<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Valores de pago",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Valores Pago",
                active: true
                }
            ],
            valores_pago:[],
            tipos:[],
            subtipos:[],
            subtiposfilter:[],
            subtiposEditar:[],
            valor:{
                tipo_id:[],
                subtipo_id:[],
                duracion_maxima:'',
                valor_liquido:'$0',
                hora_extra:'$0',
                visible:false,
                tipo_laborante:[]
            },
            valor_editar:{
                id:'',
                tipo_id:[],
                subtipo_id:[],
                duracion_maxima:'',
                valor_liquido:'$0',
                hora_extra:'$0',
                tipo_laborante:[]
            },
            tipo_laborante:['Apoyo','Relator','Digitalizador','Apoyo Oficina', 'Salida']
        };
    },
    methods:{
        ver_subtipo(tipo){
            this.subtiposfilter = this.subtipos.filter((subtipo) => subtipo.tipo_id==(tipo || this.valor.tipo_id).id);
            this.valor.subtipo_id = [];
        },
        ver_subtipo_editar(tipo){
            this.subtiposEditar = this.subtipos.filter((subtipo) => subtipo.tipo_id==tipo.id);
            this.valor_editar.subtipo_id = [];
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        format_Valor(){
            this.valor.valor_liquido=this.format_Valor_variable(this.valor.valor_liquido)
            this.valor.hora_extra=this.format_Valor_variable(this.valor.hora_extra)
            this.valor_editar.valor_liquido=this.format_Valor_variable(this.valor_editar.valor_liquido)
            this.valor_editar.hora_extra=this.format_Valor_variable(this.valor_editar.hora_extra)
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        msgval(campo) {
            Swal.fire({
                icon: 'error',
                title: 'Campo Obligatorio',
                text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 5000
            });
        },
        msg(title) {
            Swal.fire({
                icon: 'success',
                title: title,
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 5000
            });
        },
        validaciones(){
            if(this.valor.tipo_id.length==0){
                this.msgval('Tipo');
                return
            }
            if(this.valor.subtipo_id.length==0){
                this.msgval('Subtipo');
                return
            }
            if(this.valor.valor_liquido=='' || this.valor.valor_liquido==null){
                this.msgval('Valor Líquido');
                return
            }
            this.guardar();
        },
        limpiar(){
            this.valor.tipo_id= [];
            this.valor.subtipo_id=[];
            this.valor.duracion_maxima='';
            this.valor.valor_liquido='$0';
            this.valor.hora_extra='$0';
        },
        guardar(){
            let formData = new FormData();
            formData.append('tipo_id', this.valor.tipo_id.id);
            formData.append('subtipo_id', this.valor.subtipo_id.id);
            formData.append('duracion_maxima', this.valor.duracion_maxima);
            formData.append('valor_liquido', this.valor.valor_liquido);
            formData.append('hora_extra', this.valor.hora_extra);
            formData.append('tipo_laborante', this.valor.tipo_laborante);
            axios.post('/api/crear_valores_pago',formData).then(res=>{
                this.valores_pago=res.data.valores;
                this.limpiar;
                this.msg('Se ha guardado un nuevo valor.');
                this.valor.tipo_id=[];
                this.valor.subtipo_id=[];
                this.valor.duracion_maxima='';
                this.valor.valor_liquido='$0';
                this.valor.hora_extra='$0';
                this.valor.visible=false;
                this.valor.tipo_laborante=[];
            });
        },
        tipo(val){
            return this.tipos.filter((tipo) => tipo.id==val.tipo_id)[0].nombre;
        },
        subtipo(val){
            return this.subtipos.filter((subtipo) => subtipo.id==val.subtipo_id)[0].nombre;
        },
        ver_editar(val){
            this.valor_editar.tipo_id = this.tipos.filter((tipo) => tipo.id==val.tipo_id)[0];
            this.subtiposEditar = this.subtipos.filter((subtipo) => subtipo.tipo_id==val.tipo_id);
            this.valor_editar.subtipo_id = this.subtiposEditar.find((subtipo) => subtipo.id==val.subtipo_id) || [];
            this.valor_editar.duracion_maxima = val.duracion_maxima;
            this.valor_editar.valor_liquido = val.valor_liquido;
            this.valor_editar.hora_extra = val.hora_extra;
            this.valor_editar.id = val.id;
            this.valor_editar.tipo_laborante=val.tipo_laborante==null?[]:val.tipo_laborante.split(",");
        },
        editar(val){
            if (!this.valor_editar.tipo_id || !this.valor_editar.tipo_id.id) {
                this.msgval('Tipo');
                return;
            }
            if (!this.valor_editar.subtipo_id || !this.valor_editar.subtipo_id.id || this.valor_editar.subtipo_id.tipo_id != this.valor_editar.tipo_id.id) {
                this.msgval('Subtipo');
                return;
            }
            let formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo_id', this.valor_editar.tipo_id.id);
            formData.append('subtipo_id', this.valor_editar.subtipo_id.id);
            formData.append('duracion_maxima', this.valor_editar.duracion_maxima);
            formData.append('valor_liquido', this.valor_editar.valor_liquido);
            formData.append('hora_extra', this.valor_editar.hora_extra);
            formData.append('tipo_laborante', this.valor_editar.tipo_laborante);
            axios.post('/api/editar_valores_pago',formData).then(res=>{
                this.valores_pago=res.data.valores;
                this.msg('Se ha editado correctamente');
                val.visible=false
            });
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos//.filter(t=>t.codigo)
            this.subtipos=res.data.subtipos
        });
        axios.get('/api/get_valores_pago').then(res=>{
            this.valores_pago=res.data.valores;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 text-right mb-3">
                                <b-button variant="primary" v-b-modal.modal-1>Agregar</b-button>
                                <b-modal id="modal-1" title="Agregar Valor" ok-title="Guardar" cancel-title="Cancelar" @ok="validaciones()" @cancel="limpiar()">
                                    <div class="form-group row">
                                        <div class="col-md-6"><label for="pais"> Tipo:</label></div>
                                        <!-- <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div> -->
                                        <div class="col-md-12">
                                            <multiselect v-model="valor.tipo_id"
                                                :options="tipos"
                                                placeholder="Seleccionar tipo"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelselect_tipo"
                                                        @select="ver_subtipo">
                                                <template v-slot:noOptions><p>No hay opciones</p></template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-6"><label for="pais"> Subtipo:</label></div>
                                        <!-- <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div> -->
                                        <div class="col-md-12">
                                            <multiselect v-model="valor.subtipo_id"
                                                :options="subtiposfilter"
                                                placeholder="Seleccionar subtipo"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelselect_tipo" >
                                                <template v-slot:noOptions><p>No hay opciones</p></template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Duración Máxima (horas):</label>
                                        <input id="email" v-model="valor.duracion_maxima" class="form-control border-primary" @keydown="restrictToNumbers">
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Valor Líquido:</label>
                                        <input id="email" v-model="valor.valor_liquido" class="form-control border-primary" @input="format_Valor">
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Hora extra:</label>
                                        <input id="email" v-model="valor.hora_extra" class="form-control border-primary" @input="format_Valor">
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Tipo Laborante:</label>
                                        <multiselect v-model="valor.tipo_laborante"
                                            :options="tipo_laborante"
                                            placeholder="Seleccionar Laborante"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :multiple="true"
                                            >
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </b-modal>
                            </div>
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th style="width: 2%;">#</th>
                                                <th style="width: 20%;">Tipo</th>
                                                <th style="width: 20%;">Subtipo</th>
                                                <th class="text-center" style="width: 10%;">Duración Máxima</th>
                                                <th class="text-center" style="width: 10%;">Valor liquido</th>
                                                <th class="text-center" style="width: 10%;">Hora extra</th>
                                                <th style="width: 20%;">Acciones</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="table-responsive" v-for="(valor,index) in valores_pago" :key="index">
                                    <table class="table">
                                        <tbody>
                                            <tr>
                                                <th style="width: 2%;" scope="row">{{index+1}}</th>
                                                <td style="width: 20%;">{{tipo(valor)}}</td>
                                                <td style="width: 20%;">{{subtipo(valor)}}</td>
                                                <td class="text-center" style="width: 10%;">{{valor.duracion_maxima}}</td>
                                                <td class="text-center" style="width: 10%;">{{valor.valor_liquido}}</td>
                                                <td class="text-center" style="width: 10%;">{{valor.hora_extra}}</td>
                                                <td style="width: 20%;">
                                                    <b-button variant="primary" v-b-toggle="'accordion-'+valor.id" @click="ver_editar(valor)">Editar</b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <b-collapse :id="'accordion-'+valor.id" v-model="valor.visible" accordion="my-accordion" role="tabpanel">
                                        <div class="row">
                                            <div class="offset-md-2 col-md-8" >
                                                <div class="form-group row">
                                                    <div class="col-md-6"><label for="pais"> Tipo:</label></div>
                                                    <!-- <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div> -->
                                                    <div class="col-md-12">
                                                        <multiselect v-model="valor_editar.tipo_id"
                                                            :options="tipos"
                                                            placeholder="Seleccionar tipo"
                                                            selectLabel="Presiona para seleccionar"
                                                            selectedLabel="Seleccionado"
                                                            deselectLabel="Presiona para remover"
                                                            :custom-label="labelselect_tipo"
                                                            @select="ver_subtipo_editar">
                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                            <template v-slot:noResult>
                                                                <p>No se encuentra coincidencia</p>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-6"><label for="pais"> Subtipo:</label></div>
                                                    <!-- <div class="col-md-6 text-right"><label for="pais" class="text-primary"> * Campo Obligatorio</label></div> -->
                                                    <div class="col-md-12">
                                                        <multiselect v-model="valor_editar.subtipo_id"
                                                            :options="subtiposEditar"
                                                            placeholder="Seleccionar subtipo"
                                                            selectLabel="Presiona para seleccionar"
                                                            selectedLabel="Seleccionado"
                                                            deselectLabel="Presiona para remover"
                                                            :custom-label="labelselect_tipo" >
                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                            <template v-slot:noResult>
                                                                <p>No se encuentra coincidencia</p>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label for="email">Duración Máxima (horas):</label>
                                                    <input id="email" v-model="valor_editar.duracion_maxima" class="form-control border-primary" @keydown="restrictToNumbers">
                                                </div>
                                                <div class="form-group">
                                                    <label for="email">Valor Líquido:</label>
                                                    <input id="email" v-model="valor_editar.valor_liquido" class="form-control border-primary" @input="format_Valor">
                                                </div>
                                                <div class="form-group">
                                                    <label for="email">Hora extra:</label>
                                                    <input id="email" v-model="valor_editar.hora_extra" class="form-control border-primary" @input="format_Valor">
                                                </div>
                                                <div class="form-group">
                                                    <label for="email">Tipo Laborante:</label>
                                                    <multiselect v-model="valor_editar.tipo_laborante"
                                                            :options="tipo_laborante"
                                                            placeholder="Seleccionar Laborante"
                                                            selectLabel="Presiona para seleccionar"
                                                            selectedLabel="Seleccionado"
                                                            deselectLabel="Presiona para remover"
                                                            :multiple="true">
                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                            <template v-slot:noResult>
                                                                <p>No se encuentra coincidencia</p>
                                                            </template>
                                                        </multiselect>
                                                </div>
                                                <div class="text-right">
                                                    <b-button variant="primary" @click="editar(valor)">Guardar</b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
